export const esCommon = {
  // ... existing translations ...
  "welcome": "Bienvenido a GRUPO FR",
  "description": "Tu socio de confianza en bienes raíces",
  "exploreProperties": "Explorar Propiedades",
  "ourServices": "Nuestros Servicios",
  "featuredProperties": "Propiedades Destacadas",
  "aboutUs": "Acerca de Nosotros",
  "contactUs": "Contáctanos",
  "allRights": "Todos los derechos reservados",
  "propertySales": "Venta de Propiedades",
  "propertyRentals": "Alquiler de Propiedades", 
  "propertyManagement": "Gestión de Propiedades",
  "realEstateConsulting": "Consultoría Inmobiliaria",
  "propertyValuation": "Valoración de Propiedades",
  "legalSupport": "Apoyo Legal",
  "adminPanel": "Panel de Administración",
  "language": "Idioma",
  
  // Search functionality
  "propertyType": "Tipo de Propiedad",
  "location": "Ubicación", 
  "status": "Estado",
  "forSale": "En Venta",
  "forRent": "En Alquiler",
  "advancedSearch": "Búsqueda Avanzada",
  "priceRange": "Rango de Precio",
  "minPrice": "Precio Mín.",
  "maxPrice": "Precio Máx.",
  "bedrooms": "Habitaciones",
  "bathrooms": "Baños",
  "area": "Área",
  "minArea": "Área Mín.",
  "any": "Cualquiera",
  "reset": "Restablecer",
  "apartment": "Apartamento",
  "house": "Casa",
  "condo": "Condominio", 
  "office": "Oficina",
  "commercial": "Local Comercial",
  
  // Compare functionality
  "compareProperties": "Comparar Propiedades",
  "properties": "Propiedades",
  "characteristics": "Características",
  "noPropertiesToCompare": "No hay propiedades para comparar",
  "selectPropertiesToCompare": "Selecciona propiedades para comparar sus características",
  "remove": "Eliminar",
  "yearBuilt": "Año de Construcción",
  "parking": "Estacionamiento",
  "floor": "Piso",
  "furnished": "Amueblado",
  "yes": "Sí",
  "no": "No",
  "features": "Características",
  "more": "más",
  "comparingProperties": "Comparando {{count}} propiedades",
  "clearAll": "Limpiar Todo",
  "close": "Cerrar",
  "addToCompare": "Agregar a Comparar",
  "removeFromCompare": "Quitar de Comparar",
  "compare": "Comparar",
  
  // Appointment booking
  "scheduleVisit": "Agendar Visita",
  "contactInformation": "Información de Contacto",
  "fullName": "Nombre Completo",
  "enterFullName": "Ingresa tu nombre completo",
  "email": "Correo Electrónico",
  "enterEmail": "Ingresa tu correo electrónico",
  "phone": "Teléfono",
  "enterPhone": "Ingresa tu teléfono",
  "selectDateTime": "Seleccionar Fecha y Hora",
  "preferredDate": "Fecha Preferida",
  "selectDate": "Selecciona una fecha",
  "preferredTime": "Hora Preferida",
  "selectTime": "Selecciona una hora",
  "additionalMessage": "Mensaje Adicional",
  "optional": "opcional",
  "enterAdditionalMessage": "Ingresa cualquier solicitud especial o pregunta",
  "characters": "caracteres",
  "importantInformation": "Información Importante",
  "visitDuration": "La visita tiene una duración aproximada de 30-45 minutos",
  "confirmationMessage": "Recibirás un mensaje de confirmación por email y teléfono",
  "cancellationPolicy": "Puedes cancelar o reagendar con 24 horas de anticipación",
  "cancel": "Cancelar",
  "scheduling": "Agendando...",
  "appointmentConfirmed": "¡Cita Confirmada!",
  "appointmentConfirmedMessage": "Tu visita ha sido agendada exitosamente. Nos pondremos en contacto contigo pronto.",
  "appointmentDetails": "Detalles de la Cita",
  "property": "Propiedad",
  "name": "Nombre",
  "date": "Fecha", 
  "time": "Hora",
  "closingAutomatically": "Esta ventana se cerrará automáticamente...",
  "preferVoiceAssistance": "¿Prefieres agendar por voz? Usa nuestro asistente inteligente",
  "talkWithAgent": "Hablar con Agente",
  "bookVisit": "Agendar Visita"
};

export default esCommon;
